// const NO_DISPLAY = { width: 0, height: 0 };

export const GRID_LAYOUT_COMPONENTS = {
  hubletView: "hubletView",
  iframe: "iframe",
  pnl: "pnl",
  timeline: "timeline",
  trendChart: "trendChart",
};

// these heights and widths are screen size percentages
export const DEFAULT_COMPONENT_DIMENSION_PERCENTS = {
  [GRID_LAYOUT_COMPONENTS.hubletView]: {
    lg: { width: 42, height: 30 },
    md: { width: 42, height: 30 },
    sm: { width: 100, height: 60 },
    xs: { width: 100, height: 60 },
    xxs: { width: 100, height: 60 },
  },
  [GRID_LAYOUT_COMPONENTS.trendChart]: {
    lg: { width: 58, height: 70 },
    md: { width: 58, height: 70 },
    sm: { width: 100, height: 100 },
    xs: { width: 100, height: 100 },
    xxs: { width: 100, height: 100 },
  },
  [GRID_LAYOUT_COMPONENTS.pnl]: {
    lg: { width: 42, height: 70 },
    md: { width: 42, height: 70 },
    sm: { width: 100, height: 100 },
    xs: { width: 100, height: 100 },
    xxs: { width: 100, height: 100 },
  },
  [GRID_LAYOUT_COMPONENTS.timeline]: {
    lg: { width: 58, height: 30 },
    md: { width: 58, height: 30 },
    sm: { width: 100, height: 42 },
    xs: { width: 100, height: 42 },
    xxs: { width: 100, height: 42 },
  },
};
